import clsx from 'clsx';

function TableBodyRow({ children, hidden = false }) {
  return (
    <tr
      className={
        clsx(
          'transition-colors ease-in-out duration-300 odd:bg-white even:bg-dark-100',
          hidden ? 'bg-gray-200 dark:bg-gray-600' : 'dark:hover:bg-gray-900 hover:bg-dark-200'
        )
      }
    >
      {
        children
      }
    </tr>
  );
}

export default TableBodyRow;
